import React from 'react';
import {
  Box,
  HorizontalDivider,
  TransparentButton,
  Typography,
  GridContainerWithTitle,
} from '@ttx/design-system';

interface OptionProps {
  id: string;
  label: React.JSX.Element | string;
  onPress: () => void;
  icon?: React.JSX.Element;
}

export interface MultiDropModalModalProps {
  title: string;
  options: OptionProps[];
  onClose?: () => void;
}

export const MultiDropModal: React.FC<MultiDropModalModalProps> = ({
  title,
  options,
  onClose,
}) => {
  const closeProps = onClose ? {onModalClose: onClose} : {};
  return (
    <GridContainerWithTitle title={title} {...closeProps} maxWidth={400}>
      {options.map(({id, label, icon = '', onPress}, idx) => {
        const isLast = idx === options.length - 1;
        return (
          <Box key={id}>
            <Box p="lg" flexDirection="row">
              {icon && <Box width="30px">{icon}</Box>}
              <TransparentButton onPress={onPress}>
                <Typography textStyle="s" color="textDefault">
                  {label}
                </Typography>
              </TransparentButton>
            </Box>
            {!isLast && <HorizontalDivider />}
          </Box>
        );
      })}
    </GridContainerWithTitle>
  );
};
